// src/utils/bloccoRapportini.js
// ═══════════════════════════════════════════════════════════════════════════
// BLOCCO DEI RAPPORTINI DOPO LE FIRME (ottobre 2026)
//  • firmato dal tecnico E dal cliente → documento definitivo: nessuno lo modifica o
//    lo elimina (si può sempre stampare / scaricare in PDF);
//  • firmato solo dal tecnico → lo modificano o eliminano solo titolare, admin, chi ha
//    il ruolo «Project Manager» e il responsabile della commessa; gli altri possono
//    soltanto aggiungere la firma del cliente;
//  • senza firme → come sempre.
// Le stesse regole sono applicate dal database (firestore rules 53, match /rapportini):
// qui servono per spiegare con l'avviso viola perché non si può, invece di un errore.
// ═══════════════════════════════════════════════════════════════════════════

export const haFirma = v => typeof v === "string" && v.length > 0;

/** "definitivo" (tecnico + cliente) | "tecnico" (solo tecnico) | "libero" */
export function statoBlocco(r) {
  if (haFirma(r?.firmaTecnico) && haFirma(r?.firmaCliente)) return "definitivo";
  if (haFirma(r?.firmaTecnico)) return "tecnico";
  return "libero";
}

/** Titolare, admin, ruolo PM o responsabile della commessa (responsabileUid). */
export function puoModificareFirmatoTecnico({ uid, role, ruoloOperativo, isPlatformOwner, commessa } = {}) {
  return !!(isPlatformOwner || ["titolare", "admin"].includes(role) || ruoloOperativo === "pm" ||
    (uid && commessa?.responsabileUid === uid));
}

export const AVVISO_DEFINITIVO =
  "🔒 Questo rapportino è firmato dal tecnico e dal cliente: è un documento definitivo e non può più essere modificato né eliminato da nessuno. Puoi sempre stamparlo o scaricarlo in PDF.";
export const AVVISO_SOLO_TECNICO =
  "🔒 Questo rapportino è già firmato dal tecnico: possono modificarlo o eliminarlo solo il titolare e il Project Manager.";
export const AVVISO_AGGIUNGI_FIRMA_CLIENTE = " Se manca, puoi comunque aggiungere la firma del cliente con «✍️ Firma cliente».";

/**
 * Può modificare / eliminare il rapportino? Se no restituisce il testo dell'avviso viola.
 * ctx = { uid, role, ruoloOperativo, isPlatformOwner, commessa }
 */
export function verificaModificaRapportino(r, ctx) {
  const s = statoBlocco(r);
  if (s === "definitivo") return { ok: false, avviso: AVVISO_DEFINITIVO };
  if (s === "tecnico" && !puoModificareFirmatoTecnico(ctx)) return { ok: false, avviso: AVVISO_SOLO_TECNICO };
  return { ok: true };
}
